import { FC, useMemo } from "react";
import { useController } from "react-hook-form";
import { Label, NominationContainer } from "./styles";
import { useSelector } from "react-redux";
import { CurrentCompetitionSelector } from "shared/reducers/CurrentCompetitionSlice";
import CompetitionGrid from "_competition/pages/AllCompetitionsPage/CompetitionGrid";
import { useTranslation } from "react-i18next";
import { API, Competition } from "@brg/api";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { useRouteMatch } from "react-router-dom";
import { ExtraGridConditionType } from "../types/extraGridConditionType";
import { AppTester } from "supporting";

export const NominationsView: FC = () => {
    const isStart = AppTester.isStartHSE();
    const isEditPage = !!useRouteMatch('/competition-edit');
    const { competition } = useSelector(CurrentCompetitionSelector) 
    const { t, i18n: { language }} = useTranslation();
    const { field: {value: hasManyCompetitions } } = useController({ name: 'hasManyCompetitions' });
    const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(competition?.competitionId ?? '', false )
    
    const blockVisible = useMemo(() => {
        if (hasManyCompetitions !== undefined) {
            return !hasManyCompetitions
        }
        return !competition?.hasManyCompetitions
    } , [hasManyCompetitions, competition])

    const extraGridCondition = isEditPage ? ExtraGridConditionType.EDIT : ExtraGridConditionType.VIEW

    const title = useMemo(() => {
        if (isStart && competition?.contexts?.includes('russtart')) {
            return t('competition_edit.profile_label')
        } 
        return t('competition_edit.nomination_label')
    }, [isStart, competition])

    if (!competition || competition?.parentCompetitionId || blockVisible || nominations?.length === 0) {
        return null
    }

    return (
        <NominationContainer gy={24} extraPadding={isEditPage}>
            <Label>{title}</Label>
            <CompetitionGrid
                competitions={nominations}
                extraGridCondition={extraGridCondition}
                notClickableTags={true}
                isMainPage={false}
            />
        </NominationContainer>
    )
}import { FC, useMemo } from "react";
import { useController } from "react-hook-form";
import { Label, NominationContainer } from "./styles";
import { useSelector } from "react-redux";
import { CurrentCompetitionSelector } from "shared/reducers/CurrentCompetitionSlice";
import CompetitionGrid from "_competition/pages/AllCompetitionsPage/CompetitionGrid";
import { useTranslation } from "react-i18next";
import { API, Competition } from "@brg/api";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { useRouteMatch } from "react-router-dom";
import { ExtraGridConditionType } from "../types/extraGridConditionType";
import { AppTester } from "supporting";

export const NominationsView: FC = () => {
    const isStart = AppTester.isStartHSE();
    const isEditPage = !!useRouteMatch('/competition-edit');
    const { competition } = useSelector(CurrentCompetitionSelector) 
    const { t, i18n: { language }} = useTranslation();
    const { field: {value: hasManyCompetitions } } = useController({ name: 'hasManyCompetitions' });
    const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(competition?.competitionId ?? '', false )
    
    const blockVisible = useMemo(() => {
        if (hasManyCompetitions !== undefined) {
            return !hasManyCompetitions
        }
        return !competition?.hasManyCompetitions
    } , [hasManyCompetitions, competition])

    const extraGridCondition = isEditPage ? ExtraGridConditionType.EDIT : ExtraGridConditionType.VIEW

    const title = useMemo(() => {
        if (isStart && competition?.contexts?.includes('russtart')) {
            return t('competition_edit.profile_label')
        } 
        return t('competition_edit.nomination_label')
    }, [isStart, competition])

    if (!competition || competition?.parentCompetitionId || blockVisible || nominations?.length === 0) {
        return null
    }

    return (
        <NominationContainer gy={24} extraPadding={isEditPage}>
            <Label>{title}</Label>
            <CompetitionGrid
                competitions={nominations}
                extraGridCondition={extraGridCondition}
                notClickableTags={true}
                isMainPage={false}
            />
        </NominationContainer>
    )
}